/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normality = molarity × equivalents per mole. For a monoprotic acid the two are equal; for a diprotic acid the normality is twice the molarity.`)
};

const es_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidad = molaridad × equivalentes por mol. Para un ácido monoprótico ambas son iguales; para un ácido diprótico la normalidad es el doble de la molaridad.`)
};

const de_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalität = Molarität × Äquivalente pro Mol. Bei einer einprotonigen Säure sind beide gleich; bei einer zweiprotonigen Säure ist die Normalität doppelt so hoch wie die Molarität.`)
};

const nl_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliteit = molariteit × equivalenten per mol. Voor een monoprotisch zuur zijn de twee gelijk; voor een diprotisch zuur is de normaliteit twee keer de molariteit.`)
};

const fr_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalité = molarité × équivalents par mole. Pour un acide monoprotique, les deux sont égales ; pour un acide diprotique, la normalité est deux fois la molarité.`)
};

const it_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalità = molarità × equivalenti per mole. Per un acido monoprotico le due coincidono; per un acido diprotico la normalità è il doppio della molarità.`)
};

const pt_br2_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidade = molaridade × equivalentes por mol. Para um ácido monoprótico, os dois valores são iguais; para um ácido diprótico, a normalidade é o dobro da molaridade.`)
};

const pt_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidade = molaridade × equivalentes por mole. Para um ácido monoprótico, as duas são iguais; para um ácido diprótico, a normalidade é o dobro da molaridade.`)
};

const ja_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規定度 = モル濃度 × 1モルあたりの当量数。一価酸の場合、両者は等しくなります。二価酸の場合、規定度はモル濃度の2倍になります。`)
};

const zh_norm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量浓度 = 摩尔浓度 × 每摩尔当量数。对于一元酸两者相等；对于二元酸，当量浓度是摩尔浓度的两倍。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_a4", locale)
	if (locale === "en") return en_norm_faq_a4(inputs)
	if (locale === "es") return es_norm_faq_a4(inputs)
	if (locale === "de") return de_norm_faq_a4(inputs)
	if (locale === "nl") return nl_norm_faq_a4(inputs)
	if (locale === "fr") return fr_norm_faq_a4(inputs)
	if (locale === "it") return it_norm_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_a4(inputs)
	if (locale === "pt") return pt_norm_faq_a4(inputs)
	if (locale === "ja") return ja_norm_faq_a4(inputs)
	return zh_norm_faq_a4(inputs)
};